<template>
  <div class="overflow-hidden bg-gray p-2">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12" v-if="file">
        <iframe class="pdf" :src="'data:application/pdf;base64,'+file.Base64FileStream">
        </iframe>
      </div>
      <div class="col-span-12 bg-gray text-center h-screen" v-else>
        <p class="text-white h3 mt-5">Select a document to view it</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "EDMSDocument",
  props:{
    file:Object
  }
}
</script>

